import Vue from 'vue';
import {
    Toast, Empty, Button, Form, Field, CellGroup, Cell,
} from 'vant';
import App from './App.vue';
import router from './router';

import Filters from '../../plugins/filters';
import Http from '../../plugins/http';
import Api from './api';

import '../../config';
import '../../common.less';
import '../../iconfont/iconfont.css';

Vue.use(Toast);
Vue.use(Empty);
Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Cell);

Vue.use(Filters);
Vue.use(Http);
Vue.use(Api);

Vue.config.productionTip = false;

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
